// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"224":"f7d22032","301":"51aae814","610":"65d41e82"}[chunkId] + ".js";
};